import { clear } from './clear';

export const clearIfExceedsLimit = async (limitBytes = 50 * 1024 * 1024) => {
  
  // Never clear local cache while offline
  if (!navigator.onLine) return;

  if (!navigator?.storage?.estimate) return;

  try {
    const { usage = 0 } = await navigator.storage.estimate();
    if (usage > limitBytes) {
      await clear();
    }
  } catch (error) {
    console.error('Could not estimate storage usage', { error });
  }
}; 